var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSad = function SvgSad(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sad",
    d: "M16,8A16,16,0,1,0,32,24,16,16,0,0,0,16,8Zm0,28.9A12.9,12.9,0,1,1,28.9,24,12.916,12.916,0,0,1,16,36.9ZM10.839,22.968A2.065,2.065,0,1,0,8.774,20.9,2.062,2.062,0,0,0,10.839,22.968Zm10.323-4.129A2.065,2.065,0,1,0,23.226,20.9,2.062,2.062,0,0,0,21.161,18.839ZM16,27.1a8.7,8.7,0,0,0-6.7,3.135,1.548,1.548,0,1,0,2.381,1.981,5.611,5.611,0,0,1,8.632,0A1.548,1.548,0,1,0,22.7,30.232,8.7,8.7,0,0,0,16,27.1Z",
    transform: "translate(0 -8)",
    fill: "#fff"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sad.54f1ec8c.svg";
export { ForwardRef as ReactComponent };